import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MedicineLibraryProductMatch, PipesModule } from '@xmedical/core';

/**
 * A medicine library product in the medication picker's search results (#333): the name (with the query
 * highlighted), strength and dosage form, and labels for the schedule, a discontinued product and a
 * spelling-tolerant ("close") match. The add button belongs to the host's result template.
 */
@Component({
  selector: 'xm-medicine-library-product-result',
  templateUrl: './medicine-library-product-result.component.html',
  styleUrls: ['./medicine-library-product-result.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PipesModule],
})
export class MedicineLibraryProductResultComponent {
  product = input.required<MedicineLibraryProductMatch>();
  queryText = input<string>('');
}
